export function showSearchbar() {
	
	const $closeBtn = $(".search-panel .close-btn");
	const $btn = $(".toggle-search");
	const $header = $(".header");
	const $searchResults = $(".search-panel .results");
	
	$btn.on("click", () => {


		if ( $header.hasClass("show-searchbar") ) {
			closeSearch();

		} else {
			$header.addClass("show-searchbar");
			$("body").css("overflow", "hidden");
		}
	});
	
	$closeBtn.on("click", () => {
		closeSearch();
	});
	
	$(document).on("click", function (evt) {

		if ( $header.hasClass("show-searchbar") && !$(evt.target).closest(".search-panel, .toggle-search").length ) {
			closeSearch();
		}
	});
	
	function closeSearch() {
		$searchResults.html("");
		$(".ais-SearchBox-input").val("").blur();
		$header.removeClass("show-searchbar");
        $("body").css("overflow", "visible");
	}
}


// WEBPACK FOOTER //
// ./assets/js/modules/show-searchbar.js